import { Box, LinearProgress } from '@mui/material';
import BlogSkeletonCard from '@src/components/blog/blog-card-skeleton';
import { NextSeo } from 'next-seo';
import PageLayout from '@src/components/page-layout/page-layout';
import React from 'react';
import styled from '@emotion/styled';
import { useBlogs } from '@src/components/blog/hooks/use-blogs';
import { useMediaQueries } from '@src/hooks/useMediaQueries';

const BlogCardContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    width: 100%;
`;

const BlogCardContainerTwoColumn = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    width: 100%;
`;

const StyledTitle = styled.span`
    font-size: xx-large;
    font-weight: bold;
`;

const StyledLinearProgress = styled(LinearProgress)`
    margin-top: 8px;
`;

const All = () => {
    const { renderedBlogs, loading } = useBlogs();
    const { isMediumScreen } = useMediaQueries(true);

    const blogs =
        renderedBlogs.length < 1
            ? [...Array(10)].map((_, i) => (
                  <div data-testid='loading-skeleton' key={i}>
                      <BlogSkeletonCard />
                  </div>
              ))
            : renderedBlogs;

    return (
        <PageLayout
            description='Blog posts from the team at TractorZoom. Information on interesting upcoming auctions.'
            title='Tractor Zoom - Blog'
        >
            <>
                <NextSeo noindex={true} />
                <Box width='100%' margin={4}>
                    <StyledTitle>{'All Blogs'}</StyledTitle>
                    {isMediumScreen ? (
                        <BlogCardContainerTwoColumn>{blogs}</BlogCardContainerTwoColumn>
                    ) : (
                        <BlogCardContainer>{blogs}</BlogCardContainer>
                    )}
                    {loading && <StyledLinearProgress data-testid='loading' />}
                </Box>
            </>
        </PageLayout>
    );
};

export default All;
